import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useDeleteCatalogItem = () => {
  return useMutation({
    mutationFn: (data) => api.referral.deleteCatalogItem(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось удалить событие',
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Событие успешно удален',
        type: 'success',
      })
    }
  })
}
